import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { className: "bg-[#690722] pt-[6rem] pb-[1rem] overflow-hidden text-center sm:text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { className: " text-[1.25rem] px-6 leading-[1.2] sm:px-0 sm:text-[57px] text-[#fff] font-[800] text-center m-auto" }, [
  /*#__PURE__*/_createTextVNode(" How we handle the "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" delivery process ")
], -1)
const _hoisted_3 = { className: "flex flex-row mx-auto max-w-7xl px-2 sm:px-6 lg:px-8 pt-[4rem] flex-wrap pb-[6rem] text-left justify-between text-center sm:text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card1 = _resolveComponent("Card1")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Card1, {
        title: "On-Demand Booking",
        src_image: "div.icon.svg",
        content: "Lorem impum sod Lorem impum sod Lorem impum sod Lorem impum sod"
      }),
      _createVNode(_component_Card1, {
        title: "Secure & Fast Delivery",
        src_image: "div.icon (2).svg",
        content: "Lorem impum sod Lorem impum sod Lorem impum sod Lorem impum sod"
      }),
      _createVNode(_component_Card1, {
        title: "History and Tracking",
        src_image: "div.icon (1).svg",
        content: "Lorem impum sod Lorem impum sod Lorem impum sod Lorem impum sod"
      })
    ])
  ]))
}